import React, { useState } from "react";
import UserCharts from "../../UserCharts/UserCharts";
import "./AdminUserVisualisation.css";

const AdminUserVisualisation = ({ allUserData }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const handleChange = (event) => {
    const username = event.target.value;
    setSelectedOption(username);

    setStartDate("");
    setEndDate("");

    // Find the selected user from allUserData
    const user = allUserData.find((user) => user.username === username);
    setSelectedUser(user);

    // Safely extract ISO date string from { $date: ... }
    const dates = user.scores
      .map((item) => {
        if (item.date && typeof item.date === "object" && item.date.$date) {
          return new Date(item.date.$date);
        }
        return null;
      })
      .filter((date) => date && !isNaN(date.getTime()));

    if (dates.length > 0) {
      const minDateObj = new Date(Math.min(...dates));
      const maxDateObj = new Date(Math.max(...dates));
      // Format as YYYY-MM-DD in local time (AEST)
      const formatLocalDate = (date) =>
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0");
      setMinDate(formatLocalDate(minDateObj));
      setMaxDate(formatLocalDate(maxDateObj));
    } else {
      setMinDate("");
      setMaxDate("");
    }

    console.log("Selected option:", user);
  };

  return allUserData && allUserData.length > 0 ? (
    <div className="admin-visualisation">
      <h2>Per User Visualisation</h2>

      <h3>User select</h3>
      <select value={selectedOption} onChange={handleChange}>
        <option value="" disabled>
          Select a user
        </option>
        {allUserData.map((user, index) => (
          <option key={index} value={user.username}>
            {user.username}
          </option>
        ))}
      </select>

      {selectedUser &&
        selectedUser.scores &&
        selectedUser.scores.length > 0 && (
          <UserCharts
            scores={selectedUser.scores}
            startDate={startDate}
            endDate={endDate}
          />
        )}

      <h3>Date Range Filter</h3>
      <div>
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            min={minDate || undefined}
            max={
              endDate
                ? endDate < maxDate
                  ? endDate
                  : maxDate
                : maxDate || undefined
            }
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            min={
              startDate
                ? startDate > minDate
                  ? startDate
                  : minDate
                : minDate || undefined
            }
            max={maxDate || undefined}
          />
        </label>
      </div>
    </div>
  ) : null;
};

export default AdminUserVisualisation;
